import gql from "graphql-tag"

export const questionFieldsFragment = gql`
   fragment questionFields on Question {
      uuid
      contentId
      driverUuid
      driverId
      etag
      groupUuids
      tenantUuid
      status
      text
      type
      createdAt
      answers {
        contentId
        text
        value
      }
   }
`
